import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/images/learning-map/tutorial.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "absolute right-4 top-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "arraste"
  })
], -1)
const _hoisted_2 = { class: "w-full h-[1200px] relative" }
const _hoisted_3 = {
  ref: "titleLabel",
  id: "title-label",
  class: "z-50 bg-white justify-center hidden items-center flex-col absolute rounded-md shadow-md p-2"
}
const _hoisted_4 = { ref: "titleP" }
const _hoisted_5 = {
  ref: "nodeMenu",
  id: "node-menu",
  class: "z-50 w-fit bg-white hidden justify-center items-center flex-col absolute rounded-md shadow-md"
}
const _hoisted_6 = { class: "w-fit" }
const _hoisted_7 = { class: "w-[150%] flex justify-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", {
    id: "faceCircle",
    clipPathUnits: "objectBoundingBox"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "0.5",
      cy: "0.5",
      r: "0.5"
    })
  ])
], -1)
const _hoisted_9 = ["r"]
const _hoisted_10 = ["x", "y", "width", "height", "xlink:href"]
const _hoisted_11 = ["r"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createElementBlock("div", {
    id: "learning-map",
    class: "w-[98%] border-2 h-[1200px] z-10 mt-4 cursor-grab active:cursor-grabbing relative",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hiddenNodeMenu()))
  }, [
    _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, null, 512)
      ], 512),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._menuButtons, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "w-full",
            key: item
          }, [
            (item.type === _ctx.choosenNode.type)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "btn-simple w-full flex justify-center",
                  onClick: ($event: any) => (_ctx.action(item.action))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_icon, {
                        name: item.icon,
                        class: "text-h-primary-400 mr-3"
                      }, null, 8, ["name"])
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: item.title,
                  en: item.titleEN,
                })), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 512),
      _createVNode(_component_v_network_graph, {
        ref: "graph",
        class: "graph",
        configs: _ctx.configs,
        nodes: _ctx.nodes,
        edges: _ctx.edges,
        layouts: _ctx.layouts,
        "event-handlers": _ctx.eventHandlers()
      }, {
        "override-node": _withCtx(({ nodeId, ...slotProps }) => [
          _createElementVNode("circle", _mergeProps({
            class: "face-circle",
            r: `${_ctx.nodes[nodeId].width / 2}`,
            fill: "#ffffff00"
          }, slotProps), null, 16, _hoisted_9),
          _createElementVNode("image", {
            class: "face-picture cursor-pointer",
            x: _ctx.nodes[nodeId].x,
            y: _ctx.nodes[nodeId].y,
            width: _ctx.nodes[nodeId].width,
            height: _ctx.nodes[nodeId].height,
            "xlink:href": `${_ctx.nodes[nodeId].face}`,
            "clip-path": "url(#faceCircle)"
          }, null, 8, _hoisted_10),
          _createElementVNode("circle", _mergeProps({
            class: "face-circle",
            r: `${_ctx.nodes[nodeId].width / 2}`,
            fill: "none"
          }, slotProps), null, 16, _hoisted_11)
        ]),
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["configs", "nodes", "edges", "layouts", "event-handlers"])
    ])
  ]))
}